// Port of api/fuel/app/classes/controller/api/monty/buddies/sync.php
import DB from 'offline/db'
import Constants from 'offline/constants'
import Buddies from 'offline/model/buddies'
import User from 'offline/model/user'

export default function(params) {
	var buddies = null

	if (params.id) {
		buddies = Buddies.with_id(parseInt(params.id, 10) || 0)
	} else if (params.name) {
		var rows = DB.query('SELECT * FROM buddies WHERE buddies_slug = ?', [params.name])
		buddies = rows.length ? Buddies.forge(rows[0]) : null
	}

	if (!buddies) {
		return Promise.reject({ error: Constants.API_ERROR_UNAUTHORISED, offline: true })
	}

	if (buddies.has_synchronised()) {
		return Promise.resolve({
			session: { offline: true },
			data: {
				total: buddies.get_count_users(),
				completed: buddies.get_count_sync()
			}
		})
	}

	var user = User.with_id(buddies.get_user_id())
	if (!user || !user.get_count_buddies()) {
		return Promise.reject({ error: Constants.API_ERROR_USER_NOBUDDIES, offline: true })
	}

	var total = parseInt(DB.scalar('SELECT COUNT(*) FROM link_buddies_user WHERE buddies_id = ?', [buddies.get_id()]), 10) || 0
	if (!total) {
		return Promise.reject({ error: Constants.API_ERROR_USER_NOBUDDIES, offline: true })
	}

	var completed = parseInt(DB.scalar(
		'SELECT COUNT(*) FROM link_buddies_user l JOIN user u ON u.user_id = l.user_id WHERE l.buddies_id = ? AND u.user_date_sync > 0',
		[buddies.get_id()]
	), 10) || 0

	// Offline cannot queue remote buddy-user syncs, so we collapse the local progress
	// into a complete state based on the available snapshot to avoid a permanent sync loop.
	DB.run('UPDATE buddies SET buddies_count_users = ?, buddies_count_sync = ?, buddies_data_version = ? WHERE buddies_id = ?', [
		total,
		total,
		Math.floor(Date.now() / 1000),
		buddies.get_id()
	])

	return DB.save().then(function() {
		return {
			session: { offline: true },
			data: {
				total: total,
				completed: completed || total
			}
		}
	})
}
